import { PartnerWorkflowStatus } from 'clickNgo/entities/partner/configs'
import { IPartner } from 'clickNgo/entities/partner/models'
import { EPartnersCrud } from 'onboarding/api/OnboardingPartnerApi'
import { PartnerHelper } from 'onboarding/classes/helpers/PartnerHelper'
import { partnerService } from 'onboarding/services/partnerService'

export const PORTAL_PARTNER_STALE_DATA_MESSAGE =
  'Partner data is stale. The server status is no longer Draft. Please reload the page and try again.'

export const PORTAL_PARTNER_STATUS_CHECK_FAILED_MESSAGE =
  'Unable to verify the latest partner status. Please reload the page and try again.'

type TFetchPartnerWorkflowStatus = (partnerId: string) => Promise<string | null | undefined>

type TPreparePartnerForSaveResult = { status: 'ready'; partner: IPartner } | { status: 'stale' }

const fetchLatestPartnerWorkflowStatus: TFetchPartnerWorkflowStatus = async (partnerId) => {
  const partner = await partnerService.fetchChangeRequestByPartnerId(partnerId, {
    crudKey: EPartnersCrud.partnerDataForm,
    needCached: false,
    sort: [{ field: 'EntryId', dir: 'desc' }],
  })

  return partner?.WorkflowStatus
}

export const preparePartnerForSave = async (
  partner: IPartner,
  fetchPartnerWorkflowStatus: TFetchPartnerWorkflowStatus = fetchLatestPartnerWorkflowStatus
): Promise<TPreparePartnerForSaveResult> => {
  if (!PartnerHelper.isPortalPartnerRequest(partner.partnerId)) {
    return { status: 'ready', partner }
  }

  const serverWorkflowStatus = await fetchPartnerWorkflowStatus(partner.partnerId)

  if (serverWorkflowStatus !== PartnerWorkflowStatus.DRAFT) {
    return { status: 'stale' }
  }

  return {
    status: 'ready',
    partner: {
      ...partner,
      workflowStatus: PartnerWorkflowStatus.DRAFT,
    },
  }
}
